<template>
  <div>
    <div class="box-title">
      {{ $t('RecordComparison.title') }}
    </div>
    <div class="trend-row">
      <!--      <el-date-picker-->
      <!--          v-model="dateRange"-->
      <!--          size="small"-->
      <!--          class="filter-item"-->
      <!--          type="daterange"-->
      <!--          value-format="yyyy-MM-dd"-->
      <!--          range-separator="-"-->
      <!--          start-placeholder="開始日期"-->
      <!--          end-placeholder="結束日期">-->
      <!--      </el-date-picker>-->
      <el-date-picker v-show="showMonthPicker" v-model="dateRange" class="filter-item" type="month" placeholder="選擇月" format="yyyy-MM" />
      <el-date-picker v-show="showYearPicker" v-model="yearRange" type="year" placeholder="選擇年"/>
      <el-radio-group
          v-model="selectedSampling"
          size="small"
          type="primary" >
        <el-radio-button
            v-for="(value, key) in samplingOptions"
            v-show="showControl[key]"
            :key="key"
            :label="key"
            plain>
          {{ $t('RecordComparison.'+key) }}
        </el-radio-button>
      </el-radio-group>
    </div>

    <p v-if="!chartDataExist" class="font-b font-df">  {{ $t('RecordComparison.empty') }} </p>

    <!--    <div>-->
    <!--      <div style="display: flex">-->
    <!--        <span :style="'flex: 0 0 2%; height:16px; background-color: #C13E3E'"></span> <span style="margin: 0px 5px;"> 水表逆轉 </span>-->
    <!--        <span :style="'flex: 0 0 2%; height:16px; background-color: #ffb980'"></span> <span style="margin: 0px 5px;"> 數據不完整 </span>-->
    <!--        <span :style="'flex: 0 0 2%; height:16px; background-color: #FBD746'"></span> <span style="margin: 0px 5px;"> 換表 </span>-->
    <!--      </div>-->
    <!--    </div>-->

    <div style="width:100%; height:400px">
      <v-chart
          :option="waterUseChart"
          :loading="chartsLoading"
          :theme="chartsTheme"
          :update-options="{ notMerge: true}"
          style="width: 100%; height:100%"
          autoresize />
    </div>
  </div>
</template>
<script>
import { mixins } from '@/views/common/mixins.js'

export default {
  // 用水量比較圖
  name: 'RecordCamparation',
  mixins: [mixins],
  props: {
    shareUVTU: {
      type: String,
      default: 'hour'
    }
  },
  data() {
    return {
      listQuery: {
        start: this.getNDaysAgo(30, new Date()),
        end: this.parseDateTime(new Date().toISOString()),
        sampling: 'day'
      },
      listQuery2: {
        start: this.getNDaysAgo(30, new Date()),
        end: this.parseDateTime(new Date().toISOString()),
        sampling: 'day'
      },

      // 日期元件 選擇的日期範圍
      dateRange: this.$moment().local().format("YYYY-MM"),
      dateRange2: this.$moment().add(-1,'year').local().format("YYYY-MM"),
      yearRange: this.$moment().local().format("YYYY"),
      yearRange2: this.$moment().add(-1,'year').local().format("YYYY"),

      // sampling 選項
      samplingOptions: {
        'day': '日',
        'month': '月'
      },
      // 選擇的 sampling
      selectedSampling: '',

      // 圖表
      chartDataExist: false, // 是否有圖表資料
      chartDataExist2: false, // 是否有圖表資料
      xAxisData: [],
      xAxisData2: [],
      seriesData1: [],
      seriesData2: [],
      chartsLoading: false,

      // bar 異常顏色對應
      colorMap: {
        'reversed': '#C13E3E', // 逆轉, 紅
        'not completed': '#ffb980', // 數據不完整, 橘
        'replaced': '#FBD746' // 換表, 黃
      },
      showControl: {
        day: false,
        month: false
      },

      //  控制日期選擇
      showMonthPicker: false,
      showYearPicker: false,

      lineName1: this.$moment().local().format("YYYY-MM"),
      lineName2: this.$moment().add(-1,'year').local().format("YYYY-MM"),

      today: new Date(),
    }
  },
  computed: {
    currentWaterId() {
      return JSON.parse(localStorage.getItem('currentProfile')).waterId
    },
    waterUseChart() {
      let _this = this
      let option = {
        tooltip: {
          trigger: 'axis',
          formatter: function(params) {
            // console.log('formatter params0:',params[0])
            // console.log('formatter params1:',params[1])
            let warningStr0 = ''
            let warningStr1 = ''
            let value0 = ''
            let value1 = ''
            if (params[0] && params[0].data) {
              if (params[0].data.warning[0] == 'normal') {
              warningStr0 = `<p style="color: #4791DC; margin: 0"> ${_this.$t('RecordComparison.normal')} </p>`
              } else {
                params[0].data.warning.forEach(w => {
                  if (w == 'no data') {
                    warningStr0 += `<p style="color: #C13E3E; margin: 0"> ${_this.$t('RecordComparison.noData')} </p>`
                  }
                  if (w == 'reversed') {
                    warningStr0 += `<p style="color: #C13E3E; margin: 0"> ${_this.$t('RecordComparison.reversed')} </p>`
                  }
                  if (w == 'not completed') {
                    warningStr0 += `<p style="color: #FFAB66; margin: 0"> ${_this.$t('RecordComparison.notCompleted')} </p>`
                  }
                  if (w == 'replaced') {
                    warningStr0 += `<p style="color: #F5C105; margin: 0"> ${_this.$t('RecordComparison.replaced')} </p>`
                  }

                })
              }

              if (params[0].data.value == 'no data'){
                value0 = _this.$t('RecordComparison.noData')
              } else if(params[0].data.value == 'not completed') {
                value0 = '' // 數據不完整且數值為0時，不顯示數值,20230907
              } else {
                value0 = params[0].data.value ? params[0].data.value.toFixed(2) : ''
              }
            }

            if (params[1] && params[0].data) {
              if (params[1].data.warning[0] == 'normal') {
                warningStr1 = `<p style="color: #4791DC; margin: 0"> ${_this.$t('RecordComparison.normal')} </p>`
              } else {
                params[1].data.warning.forEach(w => {
                  if (w == 'no data') {
                    warningStr1 += `<p style="color: #C13E3E; margin: 0"> ${_this.$t('RecordComparison.noData')} </p>`
                  }
                  if (w == 'reversed') {
                    warningStr1 += `<p style="color: #C13E3E; margin: 0"> ${_this.$t('RecordComparison.reversed')} </p>`
                  }
                  if (w == 'not completed') {
                    warningStr1 += `<p style="color: #FFAB66; margin: 0"> ${_this.$t('RecordComparison.notCompleted')} </p>`
                  }
                  if (w == 'replaced') {
                    warningStr1 += `<p style="color: #F5C105; margin: 0"> ${_this.$t('RecordComparison.replaced')} </p>`
                  }
                })
              }

              if (params[1].data.value == 'no data'){
                value1 = _this.$t('RecordComparison.noData')
              } else if(params[1].data.value == 'not completed') {
                value1 = '' // 數據不完整且數值為0時，不顯示數值,20230907
              } else {
                value1 = params[1].data.value ? params[1].data.value.toFixed(2) : ''
              }
            }
            
            
            
            if (params[0] && params[0].data && params[1] && params[1].data) {
              return `<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:#2ec7c9;"></span>
                    <b>${_this.$t('RecordComparison.date')}:</b> ${params[0].data.startOn} <b>${_this.$t('RecordComparison.waterUsage')}:</b> ${value0} <b>(${_this.$t('RecordComparison.m3')})</b>${warningStr0}<br/>
                    <span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:#b6a2de;"></span>
                    <b>${_this.$t('RecordComparison.date')}:</b> ${params[1].data.startOn} <b>${_this.$t('RecordComparison.waterUsage')}:</b> ${value1} <b>(${_this.$t('RecordComparison.m3')})</b>${warningStr1}<br/>`
            } else {
              return ''
            }


          },
        },
        xAxis: {
          type: 'category',
          data: _this.xAxisData
        },
        yAxis: {
          type: 'value',
          name: this.$t('RecordComparison.waterUsage')+'('+this.$t('RecordComparison.m3')+')'
        },
        series: [
          {
            name: this.lineName1,
            data: _this.seriesData1,
            type: 'line',
            smooth: false,
            barMaxWidth: 20,
            label: {
              show: true,
              position: 'top',
              formatter: function(params) {
                // return params.data.value == 0 ? '': params.data.value.toFixed(4)
                if (params.data && params.data.value == 'no data') {
                  return _this.$t('RecordComparison.noData')
                } else if (params.data && params.data.value == 'not completed') {
                  return _this.$t('RecordComparison.notCompleted') // 數據不完整且數值為0時，不顯示數值,20230907
                } else {
                  return params.data.value == 0 ? '': params.data.value.toFixed(2)
                }
              }
            }
          },
          {
            name: this.lineName2,
            data: _this.seriesData2,
            type: 'line',
            smooth: false,
            barMaxWidth: 20,
            label: {
              show: true,
              position: 'top',
              formatter: function(params) {
                if (params.data && params.data.value == 'no data') {
                  return _this.$t('RecordComparison.noData')
                } else if (params.data && params.data.value == 'not completed') {
                  return _this.$t('RecordComparison.notCompleted') // 數據不完整且數值為0時，不顯示數值,20230907
                } else {
                  return params.data.value == 0 ? '': params.data.value.toFixed(2)
                }
              }
            }
          }
        ],
        legend: {
          position: 'top',
          cursor: "pointer",
        }
      }

      return option
    }

  },
  watch: {
    dateRange: function() {
      console.log('dataRange:',this.dateRange)
      this.dateRange = this.$moment(this.dateRange).local().format("YYYY-MM")
      this.dateRange2 = this.$moment(this.dateRange).add(-1,'year').local().format("YYYY-MM")
      this.lineName1 = this.dateRange
      this.lineName2 = this.dateRange2
      // this.getData()
      this.debouncePaint(this.rePaint, 2000)
    },
    yearRange: function() {
      console.log('yearRange:',this.yearRange)
      this.yearRange = this.$moment(this.yearRange).local().format("YYYY")
      this.yearRange2 = this.$moment(this.yearRange).add(-1,'year').local().format("YYYY")
      this.lineName1 = this.yearRange
      this.lineName2 = this.yearRange2
      // this.getData()
      this.debouncePaint(this.rePaint, 2000)
    },
    selectedSampling: function(val) {
      this.listQuery.sampling = val
      this.listQuery2.sampling = val
      if (val === 'day'){
        this.dateRange = this.$moment(this.dateRange).local().format("YYYY-MM")
        this.dateRange2 = this.$moment(this.dateRange).add(-1,'year').local().format("YYYY-MM")
        this.showMonthPicker = true
        this.showYearPicker = false
        this.lineName1 = this.dateRange
        this.lineName2 = this.dateRange2
      } else {
        this.yearRange = this.$moment(this.yearRange).local().format("YYYY")
        this.yearRange2 = this.$moment(this.yearRange).add(-1,'year').local().format("YYYY")
        this.showMonthPicker = false
        this.showYearPicker = true
        this.lineName1 = this.yearRange
        this.lineName2 = this.yearRange2
      }
      // this.getData()
      this.debouncePaint(this.rePaint, 2000)
    }
  },
  async created() {
    // console.log('RecordCamparation shareUVTU:', this.shareUVTU)
    //小時、日、周、月、年
    if (this.shareUVTU === 'hour' || this.shareUVTU === 'day') {
      this.showControl.day = true
      this.showControl.month = true
      this.selectedSampling = 'day'
      this.showMonthPicker = true
    } else if (this.shareUVTU === 'week' || this.shareUVTU === 'month' || this.shareUVTU === 'year') {
      this.showControl.day = false
      this.showControl.month = true
      this.selectedSampling = 'month'
      this.showYearPicker = true
    }
  },
  methods: {
    async getData() {
      this.resetChart()
      console.log('getData uvtu:',this.shareUVTU)
      this.chartsLoading = true

      let index = 1
      if (this.selectedSampling === 'day'){
        this.listQuery.start = this.$moment(this.dateRange).startOf('month').format('YYYY-MM-DD')
        this.listQuery.end = this.$moment(this.dateRange).endOf('month').format('YYYY-MM-DD')
        this.listQuery2.start = this.$moment(this.dateRange2).startOf('month').format('YYYY-MM-DD')
        this.listQuery2.end = this.$moment(this.dateRange2).endOf('month').format('YYYY-MM-DD')
        this.listQuery.sampling = 'day'
        index = 2
      } else if (this.listQuery.sampling === 'month'){
        this.listQuery.start = this.$moment(this.yearRange).startOf('year').format('YYYY-MM-DD')
        this.listQuery.end = this.$moment(this.yearRange).endOf('year').format('YYYY-MM-DD')
        this.listQuery2.start = this.$moment(this.yearRange2).startOf('year').format('YYYY-MM-DD')
        this.listQuery2.end = this.$moment(this.yearRange2).endOf('year').format('YYYY-MM-DD')
        this.listQuery.sampling = 'month'
      }
      console.log('this.listQuery:',this.listQuery)
      await this.axios.get('/api/report/profile/' + this.currentWaterId + '/record', {params: this.listQuery }).then(res => {
        this.xAxisData = [] // 初始化 很重要!
        this.seriesData1 = []
        if (res.data.length > 0) {
          this.chartDataExist = true
          let data = res.data
          console.log('data1: ', data)
          data.forEach(element => {
            let startOn000 = new Date(element.startOn)
            this.xAxisData.push(element.startOn.split('-')[index])
            let warningList = [] // 發生哪些異常
            let startOn = element.startOn
            if (this.listQuery.sampling === 'month') {
              startOn = element.startOn.split('-')[0] + "-" + element.startOn.split('-')[1]
            }
            if (startOn000 > this.today) {
              warningList.push('no data')
            } else if (element.completed && !element.replaced && !element.reversed) { // 無異常, 無需標顏色
              warningList.push('normal')
            } else {
              if (!element.completed) {
                warningList.push('not completed')
              }
              if (element.reversed) {
                warningList.push('reversed')
              }
              if (element.replaced) {
                warningList.push('replaced')
              }
            }
            // console.log('date new date:',startOn000)
            // console.log('today:',today)
            // console.log('startOn000 < today: ',startOn000 < today)
            if (startOn000 < this.today) {
              // 數據不完整且數值為0時，不顯示數值,20230907
              if(!element.completed && element.volume == 0) {
                this.seriesData1.push({
                  startOn: startOn,
                  endOn: element.endOn,
                  value: 'not completed',
                  warning: warningList
                })
              } else {
                this.seriesData1.push({
                  startOn: startOn,
                  endOn: element.endOn,
                  value: element.volumeAdjusted ? element.volumeAdjusted : (element.volume ? element.volume : null ),
                  warning: warningList
                })
              }
            } else {
              this.seriesData1.push({
                startOn: startOn,
                endOn: element.endOn,
                value: 'no data',
                warning: warningList
              })
            }
          });
          console.log('seriesData1:', this.seriesData1)
        } else {
          this.chartDataExist = false // 無圖表資料
        }
      })
      console.log('this.listQuery2:',this.listQuery2)
      await this.axios.get('/api/report/profile/' + this.currentWaterId + '/record', {params: this.listQuery2 }).then(res => {
        // this.xAxisData = [] // 初始化 很重要!
        this.seriesData2 = []
        if (res.data.length > 0) {
          this.chartDataExist2 = true
          let data = res.data
          console.log('data2: ', data)
          data.forEach(element => {
            // this.xAxisData.push(element.startOn)
            let startOn000 = new Date(element.startOn)
            let warningList = [] // 發生哪些異常
            let startOn = element.startOn
            if (this.listQuery.sampling === 'month') {
              startOn = element.startOn.split('-')[0] + "-" + element.startOn.split('-')[1]
            }
            if (startOn000 > this.today) {
              warningList.push('no data')
            } else if (element.completed && !element.replaced && !element.reversed) { // 無異常, 無需標顏色
              warningList.push('normal')
            } else {
              if (!element.completed) {
                warningList.push('not completed')
              }
              if (element.reversed) {
                warningList.push('reversed')
              }
              if (element.replaced) {
                warningList.push('replaced')
              }
            }
            if (startOn000 < this.today) {
              // 數據不完整且數值為0時，不顯示數值,20230907
              if(!element.completed && element.volume == 0) {
                this.seriesData2.push({
                  startOn: startOn,
                  endOn: element.endOn,
                  value: 'not completed',
                  warning: warningList
                })
              } else {
                this.seriesData2.push({
                  startOn: startOn,
                  endOn: element.endOn,
                  value: element.volumeAdjusted ? element.volumeAdjusted : (element.volume ? element.volume : null ),
                  warning: warningList
                })
              }
            } else {
              this.seriesData2.push({
                startOn: startOn,
                endOn: element.endOn,
                value: 'no data',
                warning: warningList
              })
            }
          });
        } else {
          this.chartDataExist2 = false // 無圖表資料
        }
        console.log('seriesData2:', this.seriesData2)
        this.chartsLoading = false
      })
    },
    // resetData() {
    //   this.xAxisData = []
    //   this.seriesData = []
    //   this.selectedSampling = 'day'
    // },
    resetChart() {
      this.seriesData1 = []
      this.seriesData2 = []
    },
    // 重新繪製圖表
    async rePaint() {
      // 判斷要畫哪個圖表
      await this.getData()
 
      this.$forceUpdate()
    },
    // 渲染 debounce 防止狂按左右鍵 狂發api請求
    debouncePaint(fn, delay) {
      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout)
      }
      this.debounceTimeout = setTimeout(() => {
        fn()
      }, delay)
    },

  }
}
</script>
